import type { FC } from "react"

import { cn } from "@productlane/lib/src/cn"
import { CustomerTierIcon } from "@productlane/ui"

import type { SelectProps } from "./types"
import { api } from "@/lib/api"
import { Select } from "./select"

export const TierSelect: FC<SelectProps & { className?: string }> = ({
	item,
	onChange,
	align = "end",
	side = "left",
	modal,
	className,
}) => {
	const customerTiersQuery = api.linear.customerTiers.useQuery(undefined, {
		cacheTime: Infinity,
		staleTime: Infinity,
	})

	const customerTiers = customerTiersQuery.data?.customerTiers.nodes || []

	return (
		<div
			className={cn("flex h-7 items-center text-sm text-secondary", className)}
		>
			<div className="w-full">
				<Select
					label="tier"
					align={align}
					side={side}
					modal={modal}
					onChange={onChange}
					item={item}
					items={customerTiers}
					Icon={CustomerTierIcon}
				/>
			</div>
		</div>
	)
}
